import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class TrendListItem extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleSelection = event => {
    event.preventDefault();
    const selectedElementId = event.currentTarget.id;
    let clearExisting = true;
    let shiftKey = false;
    if (event.ctrlKey) {
      clearExisting = false;
    }
    if (event.shiftKey) {
      shiftKey = true;
    }
    this.props.handleSelection(selectedElementId, clearExisting, shiftKey);
  };
  render() {
    const { text, id, selected } = this.props;
    return (
      <li
        onMouseDown={this.handleSelection}
        id={id}
        className={selected ? 'active' : ''}
      >
        <a>{text}</a>
      </li>
    );
  }
}

TrendListItem.propTypes = {
  handleSelection: PropTypes.func,
  text: PropTypes.string,
  id: PropTypes.number,
  selected: PropTypes.bool,
};
